import { Media, Product } from '@/payload-types'
import Link from 'next/link'
import WishButton from './WishButton'
import { State } from '@/lib/constants/enums'

export default function Card({ product, wish }: { product: Product, wish: boolean }) {
	const imageList = product.images
	const firstImage = imageList[0]?.image as Media

	const getDiscountPercentage = () => {
		return Math.floor(((product.crossedPrice - product.price) / product.crossedPrice) * 100)
	}

	return (
		<Link href={`/product/${product.id}`} className="flex flex-col gap-3 bg-transparent relative top-0 hover:top-[-5px] transition-all">
			<div className="w-full aspect-square md:aspect-auto md:h-[300px] bg-gray-200 rounded-[10px] relative overflow-hidden flex items-center justify-center">
				<WishButton isWished={wish} productId={product.id} />
				{firstImage && (
					<img
						src={firstImage.s3Url}
						alt={firstImage.alt}
						className="h-full w-full object-cover"
					/>
				)}
				{ product.state && (
					<span className={`text-sm absolute bottom-3 left-3 rounded-sm px-2 py-1 shadow-md ${product.state === 'USED' ? 'bg-optional-200': 'bg-primary-100'}`}>
						{State[product.state]}
					</span>
				)}
			</div>
			<div className="flex flex-col gap-1 grow justify-between px-2">
				<p className="text-sm font-semibold font-alt leading-snug line-clamp-2">{product.name}</p>
				<p className="font-bold text-md font-alt leading-tight ">
					{ product.crossedPrice && (
						<>
							<span className="font-semibold line-through text-sm text-gray-400">{product.crossedPrice} CFA</span>
							<br/>
						</>
					)}
					{product.price} CFA { product.crossedPrice && (
						<span className="relative bottom-[3px] text-xs font-bold text-primary bg-primary-100 py-1 px-2 rounded ml-2 mb-1">- {getDiscountPercentage()}%</span>
					)}
				</p>
			</div>
		</Link>
	)
}
